/**
 * Helper functions JWT.js
 *
 * @namespace JWT
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/JWT.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * @function JWT.parseJwt
 * @param token
 * @return {any}
 */
export function parseJwt (token) {
  if (!token) return null;

  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

/**
 *
 * @param token
 * @param considerXSecondsBeforeExpAsExpired
 * @returns {boolean}
 */
export function validJWTToken(token, considerXSecondsBeforeExpAsExpired = 10){
  if (!token) return false
  if (!Object.prototype.hasOwnProperty.call(token, 'exp')) return false
  return (token.exp >= (new Date().getTime() + considerXSecondsBeforeExpAsExpired * 1000) / 1000)
}

window.validJWTToken = validJWTToken;
